import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@repo/ui/components/alert-dialog';
import { buttonVariants } from '@repo/ui/components/button';
import { cn } from '@repo/ui/lib/cn';
import { AlertTriangle, Loader2 } from 'lucide-react';

interface PartnerSwitchDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentPartnerName: string;
  newPartnerName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

function PartnerSwitchDialog({
  open,
  onOpenChange,
  currentPartnerName,
  newPartnerName,
  onConfirm,
  onCancel,
  isLoading = false,
}: PartnerSwitchDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="bg-warning/10 mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full">
            <AlertTriangle className="text-warning h-6 w-6" />
          </div>
          <AlertDialogTitle className="text-center">
            Trocar de parceiro?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            Você já tem um relacionamento ativo com{' '}
            <span className="text-foreground font-medium">
              {currentPartnerName}
            </span>
            . Ao aceitar este convite, você iniciará um novo relacionamento com{' '}
            <span className="text-foreground font-medium">
              {newPartnerName}
            </span>{' '}
            e o relacionamento atual será encerrado.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col gap-2 sm:flex-col sm:space-x-0">
          <AlertDialogCancel
            onClick={onCancel}
            disabled={isLoading}
            className="w-full"
          >
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className={cn(buttonVariants({ variant: 'default' }), 'w-full')}
          >
            {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Confirmar troca
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export { PartnerSwitchDialog };
